<template>
  <carousel :data="data" indicators="hover" class="carodisplay"></carousel>
</template>

<script>
export default {
  data() {
    return {
      data: [
        `<div style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(255, 255, 255, 0) 100%), url(assets/images/bg/background1.jpg); background-size:cover; background-repeat: no-repeat; background-position:top center; height:80vh; min-height:400px;">
          <div class="container h-100">
            <div class="row justify-content-center align-items-end pb-5 h-100">
              <div class="col-12 col-md-8 col-lg-6 pb-5 text-center text-white">
                <h2 class="mb-4 h1">Welcome to Quick leap</h2>
                <p class="mb-4 h5">At the core of our solution are the farmers we connect to markets, the trades we enable, and the businesses we supply.</p>
                <a href="#" class="btn btn-light btn-pill text-dark border border-dark py-2">Learn More</a>
              </div>
            </div>
          </div>
        </div>`,

        `<div style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(255, 255, 255, 0) 100%), url(assets/images/bg/background26.jpg); background-size:cover; background-repeat: no-repeat; background-position:center; height:80vh; min-height:400px;">
          <div class="container h-100">
            <div class="row justify-content-center align-items-end pb-5 h-100">
              <div class="col-12 col-md-10 col-lg-8 text-center pb-5 text-white">
                <h2 class="mb-4 h1">The aggregated B2B Market place</h2>
                <p class="mb-4 h5 w-sm-100 w-lg-50 mx-auto">Buy well grade produce at scale transparently sourced from small holder farmers on the aggregated B2B market place.</p>
                  <a href="#" class="btn btn-light btn-pill text-dark border border-dark py-2">Buy Now</a>
              </div>
            </div>
          </div>
        </div>`,

        `<div style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(255, 255, 255, 0) 100%), url(assets/images/bg/background3.jpg); background-size:cover; background-repeat: no-repeat; background-position:top; height:80vh; min-height:400px;">
          <div class="container h-100">
            <div class="row justify-content-center align-items-end pb-5 h-100">
              <div class="col-12 col-md-10 col-lg-8 text-center pb-5 text-white">
                <h2 class="mb-4 h1">The aggregated B2B Market place for Processed raw materials</h2>
                <p class="mb-4 h5 w-sm-100 w-lg-50 mx-auto">Buy well grade processed and semi-processed raw materials at scale transparently sourced from the best processors on the aggregated B2B market place.</p>
                <a href="#" class="btn btn-light btn-pill text-dark border border-dark py-2">Buy Now</a>
              </div>
            </div>
          </div>
        </div>`,

        `<div style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.3) 100%), url(assets/images/bg/background4.jpg); background-size:cover; background-repeat: no-repeat; background-position:top center; height:80vh; min-height:400px;">
          <div class="container h-100">
            <div class="row justify-content-center align-items-end pb-5 h-100">
              <div class="col-12 col-lg-10 text-center text-white pb-5">
                <h2 class="mb-4 h1">The Inventory management tool</h2>
                <p class="mb-4 h5 w-sm-100 w-lg-50 mx-auto">The inventory management tool gives you the flexibility to plan out all of your raw material needs all year round and have them delivered to you whenever, wherever and in whatever quantity you desire.</p>
                  <a href="#" class="btn btn-light btn-pill text-dark border border-dark py-2">Plan Inventory</a>
              </div>
            </div>
          </div>
        </div>`,

        `<div style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0) 100%), url(assets/images/bg/background5.jpg); background-size:cover; background-repeat: no-repeat; background-position:top center; height:80vh; min-height:400px;">
          <div class="container h-100 p-2">
            <div class="row justify-content-between align-items-center align-items-md-stretch h-100">
              <div class="d-none d-lg-flex col-lg-3">
                <div class="p-3 pb-0 bg-white text-left border border-dark rounded rounded-lg">
                  <img class="img-fluid" src="assets/images/brand1.png"/>
                  <p class="text-center mb-0">Coming Soon - Quick Leap on Mobile </p>
                  <img class="my-2 img-fluid border border-dark rounded rounded-lg" src="assets/images/potatoes.jpg"/>
                  <img class="mt-2 img-fluid border border-dark rounded rounded-lg" src="assets/images/insights/projections.png"/>
                </div>
              </div>
              <div class="col-12 col-lg-9 align-self-center text-center text-md-left">
                <h5 class="mb-4 text-white">How it works - The Aggregrator</h5>
                <p class="mb-2 text-white">The aggreagator tool helps you list all of your produce/harvest, inputs, warehouses, trucks etc on the market place. Do sign up as either an aggregator, a  farmers, a trader, an input provider, a trucker or a warehouse owner/manager.</p>
                <p class="mb-2 text-white">ag·gre·gate -  /agrəˌgāt/ Create a whole formed by combining several (typically fragmented) elements, thereby creating scale  & reducing friction. </p>
                <div class="row justify-content-center align-items-center align-items-md-stretch">
                  <div class="col-md-4 col-6 my-2 my-md-0 text-center text-sm-left d-none d-md-block">
                    <div class="p-4 bg-white text-left border border-dark rounded rounded-lg h-100">
                      <img src="assets/images/icon-1.png" class="img-fluid" style="width:100px;">
                      <h6 class="my-2">Choose a profile</h6>
                      <p class="mb-0">Choose a profile that fits your description, sign up and begin....</p>
                    </div>
                  </div>
                  <div class="col-md-4 col-6 my-2 my-md-0 text-center text-sm-left d-none d-md-block">
                    <div class="p-4 bg-white text-left border border-dark rounded rounded-lg h-100">
                      <img src="assets/images/icon-2.png" class="img-fluid" style="width:70px;">
                      <h6 class="my-2">List your product</h6>
                      <p class="mb-0">List out your produce/product, or aggregate produce and earn from aggregation.</p>
                    </div>
                  </div>
                  <div class="col-md-4 col-6 my-2 my-md-0 text-center text-sm-left d-none d-md-block">
                    <div class="p-4 bg-white text-left border border-dark rounded rounded-lg h-100">
                      <img src="assets/images/icon-3.png" class="img-fluid" style="width:65px;">
                      <h6 class="my-2">Get a great deal</h6>
                      <p class="mb-0">Have access to quality buyers who will buy all of your products..</p>
                    </div>
                  </div>
                  <div class="col-md-12 text-center my-4">
                    <a href="#" class="btn btn-light btn-pill text-dark border border-dark py-2">Aggregator</a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>`
      ]
    };
  }
};
</script>

<style lang="css">
.rounded-lg {
  border-radius: 1.3rem !important;
}
</style>
